import { isHttpClientError } from "@/http/httpError";

/** 경계에서 직접 만든 사용자 안내를 외부 오류 메시지와 구분한다. */
export class AnnotationImportInputError extends Error {}

const messages: Readonly<Record<string, string>> = {
  "training.annotation_bundle_invalid_path":
    "카메라 폴더 바로 아래에 이름이 같은 PNG/YAML 짝을 넣어 주세요.",
  "training.annotation_bundle_incomplete":
    "번들 파일이 누락되었거나 전송 중 변경되었습니다. 폴더를 다시 확인해 주세요.",
  "training.annotation_bundle_too_large":
    "번들 크기 제한을 넘었습니다. 파일 수와 PNG/YAML 크기를 줄여 주세요.",
  "training.annotation_bundle_invalid":
    "번들 구성이 올바르지 않습니다. PNG 파일과 헤더, 파일 구조와 YAML 객체 목록을 확인해 주세요.",
  "training.annotation_bundle_unknown_camera":
    "Dataset에 없는 카메라가 포함되어 있습니다. 카메라 폴더 이름을 확인해 주세요.",
  "training.annotation_bundle_resolution_unknown":
    "원본 영상 해상도가 미측정이거나 여러 크기로 섞여 있습니다. 영상 검사와 데이터 정리를 마친 뒤 다시 시도해 주세요.",
  "training.annotation_bundle_resolution_mismatch":
    "PNG 크기가 원본 영상과 다릅니다. 원본 해상도의 PNG와 좌표로 폴더를 다시 선택해 주세요.",
  "training.annotation_bundle_storage_unavailable":
    "저장소에서 번들을 확인하지 못했습니다. 잠시 후 다시 시도해 주세요.",
  "dataset.not_ready": "Dataset이 아직 준비되지 않았습니다. 상태를 확인한 뒤 다시 시도해 주세요.",
};

export function annotationImportErrorText(error: unknown): string {
  if (isHttpClientError(error)) {
    const body = error.details;
    const params =
      typeof body === "object" && body !== null && "params" in body ? body.params : null;
    if (typeof params === "object" && params !== null) {
      if (
        error.code === "training.annotation_bundle_resolution_unknown" &&
        "camera" in params &&
        typeof params.camera === "string" &&
        params.camera.trim()
      ) {
        return `${params.camera}: ${messages[error.code]}`;
      }
      if (
        error.code === "training.annotation_bundle_resolution_mismatch" &&
        "relative_path" in params &&
        typeof params.relative_path === "string" &&
        params.relative_path.trim() &&
        "expected_width" in params &&
        dimension(params.expected_width) &&
        "expected_height" in params &&
        dimension(params.expected_height) &&
        "actual_width" in params &&
        dimension(params.actual_width) &&
        "actual_height" in params &&
        dimension(params.actual_height)
      ) {
        return `${params.relative_path}: PNG ${params.actual_width}×${params.actual_height}, 원본 ${params.expected_width}×${params.expected_height}입니다. 원본 해상도의 PNG와 좌표로 폴더를 다시 선택해 주세요.`;
      }
    }
    return messages[error.code ?? ""] ?? "번들을 가져오지 못했습니다. 잠시 후 다시 시도해 주세요.";
  }
  return error instanceof AnnotationImportInputError
    ? error.message
    : "파일을 전송하지 못했습니다. 연결 상태를 확인한 뒤 다시 시도해 주세요.";
}

function dimension(value: unknown): value is number {
  return typeof value === "number" && Number.isInteger(value) && value > 0 && value < 2 ** 31;
}
